import { Button, Form, Table, Switch, Spin, Modal, message, Select } from "antd";
import { getColumnSearchProps } from "../../../utils/tables";
import Header from "../../../components/HeaderList";
import { selectUser } from "../../../redux/slices/user";
import { ReactComponent as Edit } from "../../../assets/icons/edit.svg";
import { ReactComponent as Trash } from "../../../assets/icons/trash.svg";
import Editor from "./Editor";
import styles from "../styles/BranchesUI.module.css";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const { Option } = Select;

const BranchesUI = (props) => {
  const {
    loading,
    branches,
    branch,
    openEditor,
    editorVisible,
    closeEditor,
    initialFetch,
    handleTakeOut,
    handleDelivery,
    handleActiveUber,
    newBranch,
    handleBranch,
    confirmDelete,
  } = props;
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedRowKey, setSelectedRowKey] = useState(null);
  const [form] = Form.useForm();
  const user = useSelector(selectUser);
  const navigate = useNavigate()
  const hasPermission = (type) => {
    return user.rols.includes(type);
  };

  const handleSwitch = (checked, record) => {
    if (checked) {
      handleActiveUber(record.id, "", 0, true);
    } else {
      setSelectedRowKey(record.id);
      setModalVisible(true);
    }
  };

  const closeModal = () => {
    setModalVisible(false);
    form.resetFields();
  }
  
  const handleModalOk = async () => {
    try {
      const values = await form.validateFields();
      // handleActiveUber(selectedRowKey, values.razon, values.tiempo_off, false);
      handleActiveUber(selectedRowKey, values.razon, 1440, false);
      setModalVisible(false);
      form.resetFields();
    } 
    catch (error) {
      console.error(error);
      message.error('Error al enviar datos');
    }
  };

  const columns = [
    {
      title: "Zona",
      dataIndex: "zone",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Dirección",
      dataIndex: "address",
    },
    {
      title: "Teléfono",
      dataIndex: "phone",
      align: "center",
    },
    {
      title: "Dine In",
      align: "center",
      dataIndex: "eat_in",
      filters: [
        {
          text: "Activo",
          value: 1,
        },
        {
          text: "Inactivo",
          value: 0,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.take_out === value,
      render: (val, record) => (
        <Switch checked={val} onChange={() => handleTakeOut(record.id, val)} />
      ),
    },
    {
      title: "Take Out",
      align: "center",
      dataIndex: "take_out",
      filters: [
        {
          text: "Activo",
          value: 1,
        },
        {
          text: "Inactivo",
          value: 0,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.take_out === value,
      render: (val, record) => (
        <Switch checked={val} onChange={() => handleTakeOut(record.id, val)} />
      ),
    },
    {
      title: "Delivery",
      align: "center",
      dataIndex: "delivery",
      filters: [
        {
          text: "Activo",
          value: 1,
        },
        {
          text: "Inactivo",
          value: 0,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.delivery === value,
      render: (val, record) => (
        <Switch checked={val} onChange={() => handleDelivery(record.id, val)} />
      ),
    },
    {
      title: "UBER",
      align: "center",
      dataIndex: "uber",
      filters: [
        {
          text: "Activo",
          value: 1,
        },
        {
          text: "Inactivo",
          value: 0,
        },
      ],
      filterMultiple: false,
      onFilter: (value, record) => record.uber === value,
      render: (val, record) => record.uber_id?.length > 0 && (
        <Switch checked={val} onChange={(checked) => handleSwitch(checked, record)} />
      ),
    },
    {
      title: "Editar",
      align: "center",
      dataIndex: "id",
      render: (id, record) => (
        <div className={styles.actions}>
          <div className={styles.edit} onClick={() => openEditor(record)}>
            <Edit />
          </div>
          {
            hasPermission("settings") && (
              <>
              <div className={styles.divider} />
              <div className={styles.delete} onClick={() => confirmDelete(id)}>
                <Trash />
              </div>
              </>
            )
          }
        </div>
      ),
    },
  ];

  return (
    <div className={styles.view}>
      {hasPermission("settings") ? (
                <Header
                title="Sucursales"
                actions={
                  <div className={styles.buttonBranch}>
                  <Button
                  onClick={newBranch}
                  type="primary"
                  size="large"
                  className="main-button"
                >
                  NUEVA SUCURSAL
                </Button>
                <Button
                  onClick={()=>navigate('sucursal-emergencia')}
                  type="primary"
                  size="large"
                  className="main-button"
                >
                  SUCURSAL EMERGENCIA
                </Button>
                </div>
                }
              />
        )  :  (
          <Header
                title="Información de la Sucursal" />
        )}
      
      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      ) : (
        <div>
          <Table columns={columns} dataSource={branches} rowKey="id" />
        </div>
      )}
      <Modal
        destroyOnClose
        closable={false}
        visible={editorVisible}
        footer={false}
        onCancel={closeEditor}
        width={950}
      >
        <Editor
          close={closeEditor}
          branch={branch}
          initialFetch={initialFetch}
          handleBranch={handleBranch}
        />
      </Modal>
      <Modal
        destroyOnClose
        closable={false}
        title="Motivo de Desactivar Uber Eats"
        visible={modalVisible}
        onOk={handleModalOk}
        onCancel={closeModal}
        okText="Enviar"
        cancelText="Cerrar"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="razon"
            label="Razón de desactivación"
            rules={[{ required: true, message: 'Selecciona una razón' }]}
          >
            <Select placeholder="Selecciona una razón">
              <Option value="maintenance">Mantenimiento</Option>
              <Option value="otros">Otros</Option>
              <Option value="Energy">Fallo de luz</Option>
            </Select>
          </Form.Item>
          {/*  
          <Form.Item
            name="tiempo_off"
            label="Cantidad de Tiempo fuera (minutos)"
            rules={[{ required: true, message: 'Selecciona un tiempo' }]}
          >
            <Select placeholder="Selecciona tiempo">
              {[10, 20, 30, 60].map((min) => (
                <Option key={min} value={min}>
                  {min} minutos
                </Option>
              ))}
            </Select>
          </Form.Item>
          */}
        </Form>
      </Modal>
    </div>
  );
};

export default BranchesUI;
